<template>
  <div>
    
    <div class="logoArea">
      
            <b-button type="is-info" class="mr-3" style="float: right;"
                      @click="$router.push({name:'agentApproved',})">
              Back
            </b-button>
      
      <b-image :src="require('@/assets/images/direct-sign-logo.png')" responsive class="logoImage" style="width: 250px"></b-image>
      <p class="heading">Signature Certificate</p>

      <!-- details area -->
      <div v-if="owner !== ''">
        <div><p class="detailsParagraph" style="color: #7E7E8F">Created By : </p><p class="detailsParagraph">{{owner}}</p></div>
        <div><p class="detailsParagraph" style="color: #7E7E8F">Created Date Time : </p><p class="detailsParagraph">{{createdDateTime}}</p></div>
      </div>
    </div>


    <!-- Table area -->
    <section v-if="!isLoading">

      <template v-if="tableRows.length < 1" >
        <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
          <span class="ml-2 has-text-grey-lighter">No records to display</span>
        </div>
      </template>
      <div class="tableArea"
           v-else>
        <b-table
            :data="tableRows"
            :current-page="currentPage"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="invitee_name" label="Name" width="120" sortable centered v-slot="props">
            {{ props.row.invitee_name }}
          </b-table-column>

          <b-table-column field="invitee_email" label="Email" sortable v-slot="props">
            {{ props.row.invitee_email }}
          </b-table-column>

          <b-table-column field="invitee_nic" label="NIC" sortable v-slot="props">
            {{ props.row.invitee_nic }}
          </b-table-column>

          <b-table-column field="signed_date_time" label="Date/Time" sortable v-slot="props">
            {{ props.row.signed_date_time }}
          </b-table-column>

          <b-table-column field="hash_value" label="Hash Key" sortable v-slot="props">
            {{ props.row.hash_value }}
          </b-table-column>

          <b-table-column field="signed_ip" label="IP" sortable v-slot="props">
            <template v-if="props.row.signaturePath.trim() == ''">No signature uploaded</template>
            <div v-else >{{ props.row.signed_ip }}</div>
          </b-table-column>

          <b-table-column field="signed_location" label="Location" sortable v-slot="props">
            <template v-if="props.row.signaturePath.trim() == ''">No signature uploaded</template>
            <div v-else >{{ props.row.signed_location }}</div>
          </b-table-column>

          <b-table-column field="signaturePath" label="Signature" sortable v-slot="props">
            <template v-if="props.row.signaturePath.trim() == ''">No signature uploaded</template>
            <img v-else :src="$base_public_url+props.row.signaturePath" alt="signature image" style="width: 90px">
          </b-table-column>

          <b-table-column field="sign_order" label="Position" sortable v-slot="props">
            {{ props.row.sign_order }}
          </b-table-column>

          <b-table-column field="role" label="Role" sortable v-slot="props">
            {{ props.row.role }}
          </b-table-column>

        </b-table>
      </div>

    </section>

    <section v-else>
      <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
    </section>


  </div>


</template>

<script>

import axios from "axios";

export default {

  name: 'signature-certificate',

  data(){
    return{
      owner : '',
      envelopId:'',
      createdDateTime: '',

      // tableRows:[
      //   {name:"Lakeesha Ramanayaka",email:"micro@gmail.com", nic :'950545448v', datetime: "2022-09-15 5:25:36 PM", hash_value : "LKl5565665DFDFD", ip:"192.168.1.15", location:"Meegoda", signature:"images/signatureImages/Pt3KrmFE9FYc05wo7lbkFRSBzHjI8ErCUq2Nng4t.png", role:"test role"  },
      //   {name:"Lakeesha Ramanayaka",email:"micro@gmail.com", nic :'950545448v', datetime: "2022-09-15 5:25:36 PM", hash_value : "LKl5565665DFDFD", ip:"192.168.1.15", location:"Meegoda", signature:"images/signatureImages/Pt3KrmFE9FYc05wo7lbkFRSBzHjI8ErCUq2Nng4t.png", role:"test role"  },
      //   {name:"Lakeesha Ramanayaka",email:"micro@gmail.com", nic :'950545448v', datetime: "2022-09-15 5:25:36 PM", hash_value : "LKl5565665DFDFD", ip:"192.168.1.15", location:"Meegoda", signature:"images/signatureImages/Pt3KrmFE9FYc05wo7lbkFRSBzHjI8ErCUq2Nng4t.png", role:"test role"  },
      // ], // to store data rows

      tableRows:[],
      isLoading:true, // set false to test

      isPaginated: true,
      isHoverable: true,
      isBordered: true,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,
    }
  },

  methods : {
    getSignatureCertificateData(){

      const comp = this
      console.log("getSignatureCertificateData called ------------------- ")

      try {
        console.log("Requested document id : "+comp.$route.params.id)

        axios.post(comp.$base_url+'/agent/getSignatureSummaryCertificate', {
          document_uploads_table_id : comp.$route.params.id,
          auth_token:comp.$root.agentAuthToken,
        })
            .then(function (response) {

              console.log("Documents certificate data ---------------")
              console.log(response)

              if(response.data.success){

                comp.tableRows = response.data.data.inviteeSignatureData
                comp.owner = response.data.data.agent_name
                comp.createdDateTime = response.data.data.document_created_date

                comp.isLoading = false
              }
              else{
                comp.isLoading = false
                comp.$buefy.toast.open({
                  message: response.data.data.message,
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to get certificate data",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Failed to get certificate data",
          type: "is-danger",
        });
        console.log("Exception occurred in SignatureCertificate getSignatureCertificateData() : "+e.message)
      }
    },
  },

  mounted () {
    this.getSignatureCertificateData()
  }

}

</script>

<style scoped>
.logoArea{
  margin-top: 30px;
  margin-bottom: 50px;
}

.logoImage{
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 60px;
}
.heading{
  font-weight: bolder;
  font-size: 30pt;
  color: #0D5DA3;
}

.detailsParagraph{
  display: inline;
}

.tableArea{
  margin-left: 60px;
  margin-right: 60px;
}
</style>
